import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { OriginAutocompleteComponent } from './origin-autocomplete/origin-autocomplete.component';

@NgModule({
  declarations: [
    OriginAutocompleteComponent
  ],
  imports: [
    FormsModule,
    AutocompleteLibModule,
    CommonModule,
  ],
  exports: [
    OriginAutocompleteComponent
  ],
  providers: []
})
export class AutocompleteModule { }
